import type { IBundleOptionInput } from "@jti/magento";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { useAddProduct } from "@jti/ui/hooks/useAddProduct";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import AddToCartButton from "./AddToCartButton";

type TryBundleButtonProps = {
  sku: string;
  bundle: IBundleOptionInput[];
  onError: () => void;
  isLoaded: boolean;
};

const TryBundleButton = ({ sku, bundle, onError, isLoaded }: TryBundleButtonProps) => {
  const { __ } = useTranslations();
  const { isRunning, addProductToCart } = useAddProduct(sku, bundle, true, onError);
  const isLoading = isRunning || !isLoaded;

  const startFreeTrial = () => {
    dispatchTrackingEvent(TrackingEvents.TrackingFreeTrialStart);
    addProductToCart();
  };

  return (
    <AddToCartButton
      onClick={startFreeTrial}
      isLoading={isLoading}
      testId="pdpTryBundle"
      label={__("product.button.trynow")}
    />
  );
};

export default TryBundleButton;
